import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'ut-academy-quiz-choice',
  templateUrl: './quiz-choice.component.html',
  styleUrls: ['./quiz-choice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QuizChoiceComponent {
  @Input() letter!: string;
  @Input() text!: string;
  @Input() choiceId!: number;
  @Input() selected = false;

  @Output() choiceSelected = new EventEmitter<number>();

  onChoiceClick(): void {
    this.choiceSelected.emit(this.choiceId);
  }
}
